import events from '../events/events';

const Notify = {};

/**
 * Notification plugin
 *
 * @param Vue
 */
Notify.install = function(Vue)
{
    let methods =
    {
        /**
         * Default notification
         *
         * @param {string} headline
         * @param {string} description
         * @param {string} icon
         * @param {string} type
         */
        default(headline, description, icon, type)
        {
            // push notification on event bus
            events.$emit('notification.open', headline, description, icon, type);
        },

        /**
         * Defined notification for INFO
         *
         * @param {string} headline
         * @param {string} description
         */
        info(headline, description)
        {
            this.default(headline, description, 'info', 'blue');
        },

        /**
         * Defined notification for WARN
         *
         * @param {string} headline
         * @param {string} description
         */
        warn(headline, description)
        {
            this.default(headline, description, 'warning', 'orange');
        },

        /**
         * Defined notification for ERROR
         *
         * @param {string} headline
         * @param {string} description
         */
        error(headline, description)
        {
            if ( ! headline && ! description)
            {
                headline = Vue.t('error.whoops.title');
                description = Vue.t('error.whoops.headline');
            }

            this.default(headline, description, 'clear', 'red');
        },

        /**
         * Defined notification for SUCCESS
         *
         * @param {string} headline
         * @param {string} description
         */
        success(headline, description)
        {
            if ( ! headline && ! description)
            {
                headline = Vue.t('common.notify.success.headline');
                description = Vue.t('common.notify.success.description');
            }

            this.default(headline, description, 'check', 'green');
        },

        /**
         * Defined notification for DELETE
         *
         * @param {string} headline
         * @param {string} description
         */
        remove(headline, description)
        {
            if ( ! headline && ! description)
            {
                headline = Vue.t('common.notify.delete.headline');
                description = Vue.t('common.notify.delete.description');
            }

            this.default(headline, description, 'delete', 'red');
        },
    };

    // register global methods
    Vue.notify = methods;

    // register instance methods
    Vue.prototype.$notify = methods;
};

export default Notify;



// WEBPACK FOOTER //
// ./src/js/plugins/notify.js